module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ch-55323a0680e7c5ff735b3ef0b6a59555.svg";